export default "/images/61e57c63e778b7cef90cb62181207a40.avif";